// extracted by mini-css-extract-plugin
module.exports = {"SolarPanels":"SolarPanels_SolarPanels__9NArC"};